module.exports = __webpack_public_path__ + "img/6.f77da408.jpg";